import React from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Minus, Plus } from "lucide-react";
import { FIELD_TYPES } from "../utils/registrationFields";

const RegistrationFieldsEditor = ({ fields, onChange }) => {
  const updateField = (index, patch) => {
    onChange(fields.map((field, i) => (i === index ? { ...field, ...patch } : field)));
  };

  const addField = (index) => {
    const next = [...fields];
    next.splice(index + 1, 0, {
      key: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      id: "",
      label: "",
      type: "text",
      required: true,
      optionsText: "",
    });
    onChange(next);
  };

  const removeField = (index) => {
    const next = fields.filter((_, i) => i !== index);
    onChange(
      next.length
        ? next
        : [
            {
              key: `${Date.now()}-empty`,
              id: "",
              label: "",
              type: "text",
              required: true,
              optionsText: "",
            },
          ]
    );
  };

  return (
    <div className="dashboard-registration-fields">
      <Form.Label className="dashboard-section-label">Campi di iscrizione</Form.Label>
      <p className="dashboard-registration-fields__hint">
        Nome, cognome, email e password sono sempre presenti. Per le nuove applicazioni
        partiamo dal codice fiscale: puoi rimuoverlo o aggiungere altri campi.
      </p>
      {fields.map((field, index) => (
        <div className="dashboard-field-card" key={field.key || `${field.id}-${index}`}>
          <div className="dashboard-field-card__row">
            <Form.Group>
              <Form.Label>Etichetta</Form.Label>
              <Form.Control
                placeholder="Es. Codice fiscale"
                value={field.label}
                onChange={(e) => updateField(index, { label: e.target.value })}
                aria-label={`Etichetta campo ${index + 1}`}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Tipo di input</Form.Label>
              <Form.Select
                value={field.type}
                onChange={(e) => updateField(index, { type: e.target.value })}
                aria-label={`Tipo campo ${index + 1}`}
              >
                {FIELD_TYPES.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <button
              type="button"
              className="dashboard-icon-btn"
              title="Rimuovi campo"
              aria-label={`Rimuovi campo ${index + 1}`}
              onClick={() => removeField(index)}
            >
              <Minus size={18} strokeWidth={2} aria-hidden="true" />
            </button>
            <button
              type="button"
              className="dashboard-icon-btn"
              title="Aggiungi campo"
              aria-label={`Aggiungi campo dopo la riga ${index + 1}`}
              onClick={() => addField(index)}
            >
              <Plus size={18} strokeWidth={2} aria-hidden="true" />
            </button>
          </div>
          <Form.Check
            className="mt-2"
            type="checkbox"
            id={`registration-field-required-${index}`}
            label="Obbligatorio"
            checked={Boolean(field.required)}
            onChange={(e) => updateField(index, { required: e.target.checked })}
          />
          {field.type === "select" && (
            <Form.Group className="mt-2">
              <Form.Label>Opzioni (una per riga)</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder={"Sicilia\nLazio\nLombardia"}
                value={field.optionsText}
                onChange={(e) => updateField(index, { optionsText: e.target.value })}
                aria-label={`Opzioni campo ${index + 1}`}
              />
            </Form.Group>
          )}
        </div>
      ))}
      <Button
        type="button"
        variant="outline-secondary"
        className="dashboard-add-btn"
        onClick={() => addField(fields.length - 1)}
      >
        <Plus size={16} strokeWidth={2} aria-hidden="true" />
        Aggiungi campo
      </Button>
    </div>
  );
};

export default RegistrationFieldsEditor;
